import React from 'react';
import bemCn from 'bem-cn';
import SniffStars from '../../components/sniff-stars';
import './render-rating.scss';

const b = bemCn('public-park-rating');

const RenderRating = ({ handleChangeStars, rating, setRating }) => {
    return (
        <div className="public-park-rating">
            <p className="snif-p snif-semibold text-center text-left-md">Help fellow dog owners by sharing your experience here!</p>
            <div className={b('rating')}>
                <SniffStars
                    initialValue={rating}
                    onHover={setRating}
                    onChange={handleChangeStars}
                    className={b('sniff-stars')}
                    starClassName={b('star')}
                />
                <p className={b('rating_text')}>
                    <span>Terrible</span>
                    <span>Bad</span>
                    <span>OK</span>
                    <span>Good</span>
                    <span>Excellent</span>
                </p>
            </div>
        </div>
    );
};

export default RenderRating;
